import React from 'react';
import { noop } from 'lodash';
import classNames from 'classnames';
import { bool, object, func, string } from 'prop-types';
import StudioBox from '../../StudioBox';
import PackagesTabs from '../../PackagesTabs';
import ContactSeller from '../../ContactSeller';
import GigStudioCard from '../../StudioCard';
import { shouldRenderContactSeller } from '../../../utils/contactSeller';

const SidebarContent = ({
    customOrder,
    studio,
    useStickyLayout,
    className = '',
    setRef = noop
}, { general }) => {
    const { isStudio } = general;

    return (
        <aside className={classNames(className, 'sidebar-content')} ref={setRef}>

            {isStudio && <StudioBox/>}

            <PackagesTabs/>

            {shouldRenderContactSeller({ general, useStickyLayout }) && <ContactSeller customOrder={customOrder}/>}

            {!useStickyLayout && <GigStudioCard studio={studio}/>}

        </aside>
    );
};

SidebarContent.propTypes = {
    studio: object,
    customOrder: object,
    setRef: func,
    useStickyLayout: bool,
    className: string
};

SidebarContent.contextTypes = {
    general: object
};

export default SidebarContent;
